<div class="footer">
  <div class="card clearfix evtFooter">
    <div class="evtFooterContent">
      <div class="evtFooterARSKTRPLink">
        <a
          href="https://www.gov.si/drzavni-organi/organi-v-sestavi/agencija-za-kmetijske-trge-in-razvoj-podezelja/"
          ><span class="far fa-fw fa-copyright"></span> 2023 Agencija Republike slovenije <br />
          za kmetijske trge in razvoj podeželja</a
        >
      </div>

      <div class="evtFooterPolitika">
        <a [routerLink]="['/politikaZasebnosti']"> Politika zasebnosti </a>
      </div>

      <div class="evtFooterPravne">
        <a [routerLink]="['/pravnePodlage']"> Pravne podlage </a>
      </div>

      <div class="evtFooterKontakt">
        <a [routerLink]="['/kontakt']"> Kontakt </a>
      </div>

      <div class="evtFooterARSKTRPIcon">
        <img src="assets/images/arsktrpIcon.png" alt="Logotip ARSKTRP" />
      </div>
    </div>
  </div>
</div>
